export default {
  type: null,
  message: null
}
